import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { useEffect, useState } from "react";
import { SharetribeRepository } from "@/infrastructure/repositories/SharetribeRepository";
import { apiService } from "@/services";
import { loadStripe } from "@stripe/stripe-js";
import { ConfigManager } from "@/application/config/Config";
import { Dialog, DialogContent, DialogTitle ,DialogHeader} from "./ui/dialog";


export function PayoutDetailsContent() {
  const [accountType, setAccountType] = useState("");
  const [country, setCountry] = useState("");
  const [routingNumber, setRoutingNumber] = useState("");
  const [bankAccountNumber, setBankAccountNumber] = useState("");
  const [paymentMethods, setPaymentMethods] = useState<any[]>([]);
  const [stripeAccountId, setStripeAccountId] = useState("");
  console.log(stripeAccountId);
  const config = ConfigManager.getInstance().getApiConfig();
  const stripePromise = loadStripe(config.stripePublishableKey);
  const repo = new SharetribeRepository(apiService);
const [errorDialogOpen, setErrorDialogOpen] = useState(false);
const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
  async function loadDetails() {
    const resp = await repo.stripeAccountFetch();

    if (!resp || !resp.data) return;

    const id = resp.data.attributes?.stripeAccountId;
    if (id) setStripeAccountId(id);

    const accounts =
      resp.data.attributes?.stripeAccountData?.external_accounts?.data ?? [];

    setPaymentMethods(accounts);

    const primary = accounts[0];

    if (primary) {
      setAccountType(primary.account_type ?? "");
      setCountry(primary.country ?? "");
      setRoutingNumber(primary.routing_number ?? "");
      setBankAccountNumber(primary.last4 ?? "");
    }
  }

  loadDetails();
}, []);

  
const onSubmit = async () => {
  try {
    const stripe = await stripePromise;

    if (!stripe) {
      setErrorMessage("Stripe failed to load");
      setErrorDialogOpen(true);
      return;
    }

    const tokenResult = await stripe.createToken(
      "bank_account" as any,
      {
        country,
        currency: "usd",
        routing_number: routingNumber,
        account_number: bankAccountNumber,
      } as any
    );

    if (tokenResult.error) {
      setErrorMessage(tokenResult.error.message || "Stripe token error");
      setErrorDialogOpen(true);
      return;
    }

    const bankToken = tokenResult.token?.id;

    if (!bankToken) {
      setErrorMessage("Failed to create bank account token");
      setErrorDialogOpen(true);
      return;
    }

    const updateResp = await repo.addPayoutDetails(bankToken);

    if (!updateResp) {
      setErrorMessage(
        "Sharetribe rejected the payout update. Updating payout bank accounts is not allowed by Sharetribe Flex."
      );
      setErrorDialogOpen(true);
      return;
    }

    console.log("Updated payout details:", updateResp);

  } catch (err: any) {
    setErrorMessage(err.message || "Unexpected error");
    setErrorDialogOpen(true);
  }
};



  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Payout Details</CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="space-y-2">
            <Label>Account Type</Label>
            <Input
              value={accountType}
              onChange={(e) => setAccountType(e.target.value)}
              placeholder="Checking / Savings"
            />
          </div>

          <div className="space-y-2">
            <Label>Country</Label>
            <Input
              value={country}
              onChange={(e) => setCountry(e.target.value)}
              placeholder="USA / India / ..."
            />
          </div>

          <div className="space-y-2">
            <Label>Routing Number</Label>
            <Input
              value={routingNumber}
              onChange={(e) => setRoutingNumber(e.target.value)}
              placeholder="Enter routing number"
            />
          </div>

          <div className="space-y-2">
            <Label>Bank Account Number</Label>
            <Input
              value={bankAccountNumber}
              onChange={(e) => setBankAccountNumber(e.target.value)}
              placeholder="Enter bank account number"
            />
          </div>

          <Button className="w-full" onClick={onSubmit}>
            Save Details
          </Button>
        </CardContent>
      </Card>


      {paymentMethods.length > 0 && (
  <div className="space-y-4">
    <h3 className="text-lg font-semibold">Payment Methods</h3>

    {paymentMethods.map((pm, idx) => (
      <div key={idx} className="p-4 border rounded-lg bg-muted">
        <p><strong>Type:</strong> {pm.object}</p>

        {pm.object === "bank_account" && (
          <>
            <p><strong>Bank Name:</strong> {pm.bank_name}</p>
            <p><strong>Country:</strong> {pm.country}</p>
            <p><strong>Routing Number:</strong> {pm.routing_number}</p>
            <p><strong>Account Last4:</strong> **** {pm.last4}</p>
            <p><strong>Status:</strong> {pm.status}</p>
          </>
        )}

        {pm.object === "card" && (
          <>
            <p><strong>Brand:</strong> {pm.brand}</p>
            <p><strong>Last4:</strong> **** {pm.last4}</p>
            <p><strong>Exp:</strong> {pm.exp_month}/{pm.exp_year}</p>
          </>
        )}
      </div>
    ))}
  </div>
)}

<Dialog open={errorDialogOpen} onOpenChange={setErrorDialogOpen}>
  <DialogContent>
    <DialogHeader>
      <DialogTitle>Error</DialogTitle>
    </DialogHeader>

    <p className="text-red-500 font-medium">{errorMessage}</p>

    <div className="mt-4 flex justify-end">
      <Button onClick={() => setErrorDialogOpen(false)}>Close</Button>
    </div>
  </DialogContent>
</Dialog>


    </div>
  );
}
